import { useCallback } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { IGame } from 'js/hooks/games/types';
import { useGameConfigurationSelector, useDeviceSelector } from 'js/store/hooks';

export const useGetGameConfig = () => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const games = useGameConfigurationSelector(prop('games'));

    return useCallback((gameCode: string): IGame | null => {
        const game = games?.[gameCode];

        if (!game) {
            log('error', `Game with game code: ${gameCode} is not configured`);

            return null;
        }

        return {
            ...game,
            ...!isDesktop && { mobileGameCode: game.mobileGameCode || game.gameCode }
        };
    }, [isDesktop, games]);
};
